import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { consumePendingRedirect, readPendingRedirect } from '../hooks/pendingRedirect'

export const Route = createFileRoute('/_unauthenticated')({
  component: () => <Outlet />,
  beforeLoad({ context: { auth }, search: { redirect_to }, location }) {
    const { isAuthorized } = auth

    if (isAuthorized) {
      const preserveRedirect =
        location.pathname.startsWith('/signup') || location.pathname.startsWith('/sso') || redirect_to != null
      const pendingRedirect = preserveRedirect ? readPendingRedirect() : consumePendingRedirect()
      throw redirect({
        to: redirect_to ?? pendingRedirect ?? '/',
        search: true,
        state: true,
        hash: true,
        replace: true,
      })
    }

    return true
  },
})
